{
  "name": "@parkingless/console",
  "version": "2.0.7",
  "private": true,
  "engines": {
    "node": ">=20.19.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration development",
    "start:prod": "ng serve --configuration production",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "patch": "node ../../scripts/version-git.mjs check && npm version patch --git-tag-version false --no-workspaces-update && node ../../scripts/version-git.mjs commit",
    "minor": "node ../../scripts/version-git.mjs check && npm version minor --git-tag-version false --no-workspaces-update && node ../../scripts/version-git.mjs commit",
    "major": "node ../../scripts/version-git.mjs check && npm version major --git-tag-version false --no-workspaces-update && node ../../scripts/version-git.mjs commit",
    "deploy:dev": "ng build --configuration dev-hosting && firebase deploy --only hosting --project parkingless-dev-6a8a1",
    "deploy:prod": "ng build --configuration production && firebase deploy --only hosting --project parkingless",
    "deploy:beta": "ng build --configuration production && firebase deploy --only hosting --project parkingless --config firebase.beta.json",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,json}\"",
    "typecheck": "tsc -p tsconfig.typecheck.json && tsc -p e2e/tsconfig.json",
    "start:emulator": "ng serve --configuration emulator --host 127.0.0.1",
    "emulators": "node e2e/run-emulators.mjs",
    "e2e": "node e2e/run-emulators.mjs \"playwright test -c e2e/playwright.config.ts\"",
    "e2e:ui": "node e2e/run-emulators.mjs \"playwright test -c e2e/playwright.config.ts --ui\"",
    "e2e:headed": "node e2e/run-emulators.mjs \"playwright test -c e2e/playwright.config.ts --headed\"",
    "typecheck:e2e": "tsc -p e2e/tsconfig.json"
  },
  "dependencies": {
    "@angular/animations": "^20.3.30",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.30",
    "@angular/compiler": "^20.3.30",
    "@angular/core": "^20.3.30",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.30",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.30",
    "@angular/platform-browser-dynamic": "^20.3.30",
    "@angular/router": "^20.3.30",
    "@parkingless/interface": "workspace:^",
    "@paypal/paypal-js": "^8.4.2",
    "angular-calendar": "^0.32.2",
    "angular-draggable-droppable": "^9.0.1",
    "angular-resizable-element": "^8.0.3",
    "apexcharts": "^6.10.0",
    "date-fns": "^4.4.0",
    "esc-pos-encoder": "^3.0.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "libphonenumber-js": "^1.13.14",
    "ng-apexcharts": "^3.1.0",
    "ngx-scrollbar": "^18.0.0",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.0.4",
    "@angular/cli": "~20.0.4",
    "@angular/compiler-cli": "^20.0.5",
    "@eslint/js": "^9.39.5",
    "@parkingless/test-contracts": "workspace:^",
    "@playwright/test": "^1.63.0",
    "@types/esc-pos-encoder": "^1.3.4",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.8",
    "@types/node": "^24.10.1",
    "@types/w3c-web-usb": "^1.0.14",
    "angular-eslint": "^20.0.0",
    "eslint": "^9.18.0",
    "eslint-config-prettier": "^10.0.1",
    "firebase-admin": "^14.3.0",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.4.2",
    "sass": "^1.89.2",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.20.0"
  }
}
